import { resolveComponent as a, resolveDirective as B, openBlock as r, createElementBlock as c, createElementVNode as f, toDisplayString as h, createBlock as s, withCtx as n, createTextVNode as v, createCommentVNode as o, withDirectives as y, normalizeClass as E, vModelDynamic as F, createVNode as m, renderSlot as S } from "vue";
import { _ as N } from "./_plugin-vue_export-helper-dad06003.js";
import { A as V } from "./AlertCircleIcon-61966fff.js";
import { H as A } from "./HelpIcon-2069ddad.js";
import { C as D } from "./CheckIcon-91388c05.js";
import { A as T } from "./AlertTriangleIcon-d613f6a8.js";
import { B as H } from "./BadgeGraySm-db599b39.js";
import { _ as W, g as x } from "./CardVideo-d193ca09.js";
import { c as G, f as q } from "./string-30844d53.js";
import { _ as z } from "./SlideDownTransition-6bc064ec.js";
import { useNotificationHandler as M } from "./useNotificationHandler.js";
const R = {
  name: "FormInput",
  components: {
    FormNotification: W,
    AlertCircleIcon: V,
    HelpIcon: A,
    AlertTriangleIcon: T,
    CheckIcon: D,
    BadgeGraySm: H,
    SlideDownTransition: z
  },
  props: {
    modelValue: {
      type: [String, Number],
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    placeholder: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "text"
    },
    error: {
      type: String,
      default: ""
    },
    help: {
      type: String,
      default: ""
    },
    autofocus: {
      type: Boolean,
      default: !1
    },
    required: {
      type: Boolean,
      default: !1
    },
    tooltip: {
      type: String,
      default: ""
    },
    pattern: {
      type: String,
      default: ""
    },
    warning: {
      type: String,
      default: ""
    },
    success: {
      type: String,
      default: ""
    },
    textCenter: {
      type: Boolean,
      default: !1
    },
    isInvalid: {
      type: Boolean,
      default: !1
    },
    inputmode: {
      type: String,
      default: "text"
    },
    autocomplete: {
      type: String,
      default: "off"
    },
    badge: {
      type: String,
      default: ""
    }
  },
  emits: ["update:modelValue", "focus", "blur"],
  setup(e) {
    return M(e);
  },
  data() {
    return {
      id: x()
    };
  },
  computed: {
    model: {
      get() {
        return this.modelValue;
      },
      set(e) {
        G({ value: e, pattern: this.pattern }) && this.$emit(
          "update:modelValue",
          q({ value: e, pattern: this.pattern, field: this.$refs.input })
        );
      }
    }
  },
  mounted() {
    this.autofocus && this.$refs.input.focus();
  }
}, U = { "data-scroll": "" }, j = ["for"], J = {
  key: 1,
  class: "ct-text-error"
}, K = { class: "relative rounded-lg shadow-sm shadow-gray-900/5" }, L = ["id", "type", "placeholder", "disabled", "inputmode", "autocomplete"], O = {
  key: 0,
  class: "pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3"
};
function P(e, i, t, Q, p, g) {
  const w = a("BadgeGraySm"), k = a("HelpIcon"), _ = a("AlertCircleIcon"), C = a("AlertTriangleIcon"), I = a("CheckIcon"), d = a("FormNotification"), u = a("SlideDownTransition"), b = B("tooltip");
  return r(), c("div", U, [
    t.title ? (r(), c("label", {
      key: 0,
      for: p.id,
      class: "flex items-center text-sm font-medium leading-6 ct-text-2 space-x-1 mb-2"
    }, [
      f("span", null, h(t.title), 1),
      t.badge ? (r(), s(w, { key: 0 }, {
        default: n(() => [
          v(h(t.badge), 1)
        ]),
        _: 1
      })) : o("", !0),
      t.required ? (r(), c("span", J, "*")) : o("", !0),
      t.tooltip ? y((r(), s(k, {
        key: 2,
        class: "cursor-pointer ct-fg-4 h-4 w-4"
      }, null, 512)), [
        [b, { content: t.tooltip }]
      ]) : o("", !0)
    ], 8, j)) : o("", !0),
    f("div", K, [
      y(f("input", {
        id: p.id,
        ref: "input",
        "onUpdate:modelValue": i[0] || (i[0] = (l) => g.model = l),
        type: t.type,
        class: E(["ct-input", {
          "is-error": e.showErrorClass,
          "is-warning": e.hasWarning && !e.showErrorClass,
          "is-success": e.hasSuccess && !e.showErrorClass && !e.hasWarning,
          "text-center": t.textCenter
        }]),
        placeholder: t.placeholder,
        disabled: t.disabled,
        inputmode: t.inputmode,
        autocomplete: t.autocomplete,
        onBlur: i[1] || (i[1] = (l) => e.$emit("blur", l)),
        onFocus: i[2] || (i[2] = (l) => e.$emit("focus", l))
      }, null, 42, L), [
        [F, g.model]
      ]),
      e.showErrorClass || e.hasWarning || e.hasSuccess ? (r(), c("div", O, [
        e.showErrorClass ? (r(), s(_, {
          key: 0,
          class: "h-4 w-4 text-error-500 dark:text-error-400",
          "aria-hidden": "true"
        })) : o("", !0),
        e.hasWarning && !e.showErrorClass ? (r(), s(C, {
          key: 1,
          class: "h-4 w-4 text-warning-400 dark:text-warning-400",
          "aria-hidden": "true"
        })) : o("", !0),
        e.hasSuccess && !e.showErrorClass && !e.hasWarning ? (r(), s(I, {
          key: 2,
          class: "h-4 w-4 text-success-500 dark:text-success-400",
          "aria-hidden": "true"
        })) : o("", !0)
      ])) : o("", !0)
    ]),
    m(u, { speed: 0.25 }, {
      default: n(() => [
        e.hasHelp ? (r(), s(d, {
          key: 0,
          message: t.help,
          help: ""
        }, {
          default: n(() => [
            S(e.$slots, "help")
          ]),
          _: 3
        }, 8, ["message"])) : o("", !0)
      ]),
      _: 3
    }),
    m(u, { speed: 0.25 }, {
      default: n(() => [
        e.hasError ? (r(), s(d, {
          key: 0,
          message: t.error,
          error: ""
        }, {
          default: n(() => [
            S(e.$slots, "error")
          ]),
          _: 3
        }, 8, ["message"])) : o("", !0)
      ]),
      _: 3
    }),
    m(u, { speed: 0.25 }, {
      default: n(() => [
        e.hasWarning ? (r(), s(d, {
          key: 0,
          message: t.warning,
          "inner-classes": "mt-2 text-sm ct-text-warning"
        }, null, 8, ["message"])) : o("", !0)
      ]),
      _: 1
    }),
    m(u, { speed: 0.25 }, {
      default: n(() => [
        e.hasSuccess ? (r(), s(d, {
          key: 0,
          message: t.success,
          "inner-classes": "mt-2 text-sm ct-text-success"
        }, null, 8, ["message"])) : o("", !0)
      ]),
      _: 1
    })
  ]);
}
const ie = /* @__PURE__ */ N(R, [["render", P]]);
export {
  ie as F
};
